<template>
  <div class="fullscreen" :key="currentSlideId">
    <SlideView
      with-project-dialog
      with-annotations
      with-diagnosis-controls
      :float-mode="floatMode"
      @float-mode:changed="floatMode = $event"
      ref="view"
      @running-operations:changed="onRunningOperationsChanged"
      @next-slide="onNextSlide"
      @previous-slide="onPreviousSlide"
      @go-to-slide="goToSlide"
      @finalize="finalize"
    ></SlideView>
    <v-dialog persistent v-model="dialog" max-width="300">
      <v-card class="pb-3">
        <v-card-text
          class="d-flex flex-column pa-3 justify-center align-center"
        >
          <div class="text-h5 mb-5">{{ $t("annotation.visualization.completingOperations") }}</div>
          <v-progress-circular indeterminate />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SlideView from "@/components/slide/SlideView";
import { ANNOTATE_NEXT, SET_CURRENT_SLIDE, CURRENT_SLIDE, ANNOTATE_PREVIOUS } from "@/store/modules/annotation";

export default {
  components: { SlideView },
  data() {
    return {
      floatMode: false,
      dialog: false,
      next: null
    };
  },
  computed: {
    currentSlideId() {
      return this.$store.getters[CURRENT_SLIDE].id;
    },
    finalizeWarningNotification() {
      return this.$t("diagnosis.table.notFinished")
    },
  },
  methods: {
    onRunningOperationsChanged(val) {
      if (!val && this.next !== null) {
        this.dialog = false;
        this.next();
      }
    },
    async onNextSlide() {
      try {
        const next = await this.$store.dispatch(ANNOTATE_NEXT);
        this.$router.push({
          name: "diagnose-visualize",
          params: { id: this.$store.getters[CURRENT_SLIDE].id }
        });
      } catch (e) {
        // no more slides available
        this.$router.push({ name: "diagnosis-dashboard", query: { a: 1 } });
      }
    },
    async onPreviousSlide() {
      try {
        const next = await this.$store.dispatch(ANNOTATE_PREVIOUS);
        this.$router.push({
          name: "diagnose-visualize",
          params: { id: this.$store.getters[CURRENT_SLIDE].id }
        });
      } catch (e) {
        // no more slides available
        this.$router.push({ name: "diagnosis-dashboard" });
      }
    },
    async goToSlide(slide) {
      const currentId = this.$store.getters[CURRENT_SLIDE].id;
      if (currentId === slide.id) return
      await this.$store.dispatch(SET_CURRENT_SLIDE, { slide: slide });
      this.$router.push({
        name: "diagnose-visualize",
        params: { id: this.$store.getters[CURRENT_SLIDE].id }
      })
    },
    finalize(status) {
      // if (!status)
      //   this.$notify({
      //     type: "warning",
      //     text: finalizeWarningNotification,
      //   });
      this.$router.push({ name: "diagnosis-dashboard", query: { status: status } });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.view !== undefined) {
      const ref = this.$refs.view.$refs.annotationControls;
      if (!ref || !ref.hasRunningOperations) {
        next();
      } else {
        this.dialog = true;
        this.next = next;
      }
    } else {
      this.dialog = true;
      this.next = next;
    }
  }
};
</script>

<style lang="scss" scoped>
.fullscreen {
  height: 100%;
  width: 100%;
}
</style>
